var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContainer = function SvgIconContainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.661 55.942H5.334V26.668h53.327zm-50.596-2.73H55.93V29.399H8.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.12 34.295a6.817 6.817 0 1 0 0 13.635 6.817 6.817 0 0 0 0-13.635m-9.548 6.817a9.55 9.55 0 0 1 9.548-9.548 9.548 9.548 0 1 1-9.548 9.548M15.33 39.058a2.055 2.055 0 1 0 0 4.11 2.055 2.055 0 0 0 0-4.11m-4.785 2.055a4.786 4.786 0 1 1 9.571 0 4.786 4.786 0 0 1-9.571 0M48.63 39.058a2.055 2.055 0 1 0 0 4.11 2.055 2.055 0 0 0 0-4.11m-4.786 2.055a4.785 4.785 0 1 1 9.57 0 4.785 4.785 0 0 1-9.57 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.795 50.48H5.334v5.462h5.461zM10.795 26.668H5.334v5.461h5.461zM58.66 50.48H53.2v5.462h5.46zM58.66 26.667H53.2v5.461h5.46z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#b)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 10.5v3.001c2.627 0 4.874-1.56 5.773-3.761V25h1.763V5h-1.763c-.21 2.993-2.584 5.5-5.773 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.464 25V5h1.763c.21 2.993 2.584 5.5 5.773 5.5v3.001c-2.627 0-4.873-1.56-5.773-3.761V25z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 24V2h22v22z"
  })))));
};
export { SvgIconContainer as Icon };
export default __webpack_public_path__ + "static/media/cf0140b30ef4a323bb9bb1f0887fea04.svg";